var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "login" } },
    [
      _c("div", { ref: "loginContainer", staticClass: "login-container" }, [
        _c("div", { staticClass: "center-parent" }, [
          _c("div", { staticClass: "logo" }),
          _vm._v(" "),
          _c("div", { staticClass: "inputs" }, [
            _c("form", [
              _c(
                "div",
                {
                  staticClass: "forgot-text",
                  class: { toggled: _vm.forgotToggle }
                },
                [
                  _vm._v(
                    "Enter your email below, and we'll send you password reset instructions."
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "input move",
                  class: { toggled: _vm.forgotToggle }
                },
                [
                  _c("v-text-field", {
                    ref: "inputEmail",
                    attrs: {
                      rules: _vm.validation.emailRules,
                      "validate-on-blur":
                        !!_vm.$refs.inputEmail && _vm.$refs.inputEmail.valid,
                      box: "",
                      "hide-details": "",
                      placeholder: "email@address.com",
                      type: "email"
                    },
                    on: {
                      focus: _vm.inputFocused,
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.emailEnterKeyed($event)
                      }
                    },
                    model: {
                      value: _vm.email,
                      callback: function($$v) {
                        _vm.email = typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "email"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "input hide",
                  class: { toggled: _vm.forgotToggle }
                },
                [
                  _c("v-text-field", {
                    ref: "inputPassword",
                    attrs: {
                      rules: _vm.validation.passwordRules,
                      "validate-on-blur":
                        !!_vm.$refs.inputPassword &&
                        _vm.$refs.inputPassword.valid,
                      box: "",
                      "hide-details": "",
                      placeholder: "password",
                      type: "password",
                      autocomplete: "off"
                    },
                    on: {
                      focus: _vm.inputFocused,
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.login($event)
                      }
                    },
                    model: {
                      value: _vm.password,
                      callback: function($$v) {
                        _vm.password =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "password"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { ref: "scrollTarget" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "buttons" }, [
            _c(
              "div",
              { staticClass: "button-holder" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "button forgot",
                    attrs: { flat: "" },
                    on: { click: _vm.toggleForgot }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.forgotToggle ? "BACK TO LOGIN" : "FORGOT PASSWORD"
                      )
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "button login",
                    attrs: { loading: _vm.loginLockout },
                    on: {
                      click: function($event) {
                        _vm.forgotToggle ? _vm.forgot() : _vm.login()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.forgotToggle ? "SEND" : "LOG IN"))]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clear" })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "clear" })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "vo-scrim", class: { active: _vm.appPrompt } })
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "app-prompt" } }, [
        _vm.appPrompt
          ? _c("div", { staticClass: "mobile-prompt" }, [
              _c("div", { staticClass: "logo" }),
              _vm._v(" "),
              _c("div", { staticClass: "text" }, [
                _vm._v("For a better experience, please download our free "),
                _c("span", [_vm._v(_vm._s(_vm.mobile) + " app.")])
              ]),
              _vm._v(" "),
              _vm.mobile === "Android"
                ? _c("div", {
                    staticClass: "app-button",
                    style: {
                      backgroundImage: "url(./assets/apps/play-store.png)"
                    },
                    on: {
                      click: function($event) {
                        _vm.openLink("android")
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.mobile === "iOS"
                ? _c("div", {
                    staticClass: "app-button",
                    style: {
                      backgroundImage: "url(./assets/apps/app-store.svg)"
                    },
                    on: {
                      click: function($event) {
                        _vm.openLink("ios")
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.mobile === "Android"
                ? _c("div", {
                    staticClass: "screenshot",
                    style: {
                      backgroundImage: "url(./assets/apps/phones-android.png)"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.mobile === "iOS"
                ? _c("div", {
                    staticClass: "screenshot",
                    style: {
                      backgroundImage: "url(./assets/apps/phones-ios.png)"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "buttons" }, [
                _c(
                  "div",
                  {
                    staticClass: "button",
                    on: {
                      click: function($event) {
                        _vm.hideAppPrompt(true)
                      }
                    }
                  },
                  [_vm._v("NEVER SHOW"), _c("br"), _vm._v("THIS AGAIN")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "button",
                    on: {
                      click: function($event) {
                        _vm.hideAppPrompt(false)
                      }
                    }
                  },
                  [_vm._v("REMIND ME"), _c("br"), _vm._v("LATER")]
                )
              ])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef68022e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef68022e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 518
// module chunks = 4